// Development environment configuration
const server = 'https://api.dev-cart.dim3.io';

export const environment = {
  production: false,
  server,
  api: server + '/api/v1',
  // Collecteur propre à cet environnement : chaque stack a son GlitchTip
  // (docker-compose.yml), et le projet y est créé au premier démarrage par
  // glitchtip-init. Sa clé publique n'est pas tirée au hasard — elle est fixée
  // par GLITCHTIP_PROJECT_KEY dans le .env de l'environnement, ce qui permet
  // d'écrire ce DSN avant même que l'instance existe. Les deux doivent rester
  // d'accord : sans quoi les erreurs sont refusées par le collecteur.
  sentryDsn:
    'https://a91e250b3c574fbeaa2439c16cf8a99f@glitch-tip.dev-cart.dim3.io/1',
};
